export const EMPTY_TRANSFORM_VALUE = '-----'
export const TRANSFORM_KEY = 'transform_data_'

export const checkKeyTransformData = (key: string): boolean => {
    if (!key) {
        return
    }
    return key.includes(TRANSFORM_KEY)
}

export const getRootKeyTransformData = (key: string): string => {
    if (!key) {
        return
    }
    return key.replace(TRANSFORM_KEY, '')
}


export const getKeyTransformData = (key: string): string => {
    return `${TRANSFORM_KEY}${key}`
}
export const copyObj = <Obj extends object>(obj: Obj): Obj => {
    if (!obj) {
        return
    }
    return JSON.parse(JSON.stringify(obj))
}

export const getValueTransformData = <Row extends object>(
    content: Row,
    key: keyof Row | 'action',
    emptyValue: string | number = EMPTY_TRANSFORM_VALUE
):string | number => {
    if (!content) {
        return emptyValue
    }

    if (!key) {
        return emptyValue;
    }

    const transformKey = getKeyTransformData(key as string)
    if (content[transformKey as keyof Row]) {
        return content[transformKey as keyof Row] as string
    }

    if (content[key as keyof Row]) {
        return content[key as keyof Row] as string
    }

    return emptyValue;
}